import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return createStyles({
        principal: (_a = {
                display: 'flex',
                position: 'relative'
            },
            _a[theme.breakpoints.down('sm')] = {
                alignItems: 'center',
                flexDirection: 'column',
            },
            _a),
        texto: {
            position: 'absolute',
        },
        circulo: (_b = {
                display: 'flex',
                position: 'relative',
                justifyContent: 'center',
                alignItems: 'center',
                width: '2.75rem',
                height: '2.75rem',
                marginTop: '3rem',
                marginBottom: '0.875rem',
                borderRadius: '50%',
                marginRight: '9.25rem',
                backgroundColor: 'var(--gris-l93)',
                '&:first-child': (_c = {
                        marginLeft: '6.5rem',
                        '&::before': (_d = {
                                width: '6.5rem',
                                transform: 'translateX(-4.6rem)'
                            },
                            _d[theme.breakpoints.down('sm')] = {
                                width: '2.5rem',
                                transform: 'translateY(-2.625rem) rotate(90deg)',
                            },
                            _d)
                    },
                    _c[theme.breakpoints.down('sm')] = {
                        marginLeft: '0',
                        marginRight: '9.375rem',
                    },
                    _c),
                '&::before': (_e = {
                        display: 'block',
                        position: 'absolute',
                        content: '""',
                        width: '9.125rem',
                        height: '.25rem',
                        transform: 'translateX(-6rem)'
                    },
                    _e[theme.breakpoints.down('sm')] = {
                        width: '2.5rem',
                        transform: 'translateY(-2.625rem) rotate(90deg)',
                    },
                    _e),
                '&:last-child': (_f = {
                        marginRight: '6.5rem',
                        '&::after': (_g = {
                                display: 'block',
                                position: 'absolute',
                                content: '""',
                                width: '6.5rem',
                                height: '.25rem',
                                transform: 'translateX(4.6rem)',
                                backgroundColor: 'var(--gris-l93)'
                            },
                            _g[theme.breakpoints.down('sm')] = {
                                width: '2.5rem',
                                transform: 'translateY(2.625rem) rotate(90deg)',
                            },
                            _g)
                    },
                    _f[theme.breakpoints.down('sm')] = {
                        margin: '2.5rem 9.375rem 2.5rem 0',
                    },
                    _f)
            },
            _b[theme.breakpoints.down('sm')] = {
                justifyContent: 'start',
                margin: '2.5rem 9.375rem 0 0',
            },
            _b),
        ocultarPrimeraLinea: {
            '&:first-child': {
                '&::before': {
                    display: 'none',
                },
            },
        },
        ocultarUltimaLinea: {
            '&:last-child': {
                '&::after': {
                    display: 'none',
                },
            },
        },
        amarillo: {
            backgroundColor: 'var(--amarillo-l44)',
        },
        verdeClaro: {
            backgroundColor: 'var(--verde-exito)',
        },
        verdeOscuro: {
            backgroundColor: 'var(--verde-l33)',
        },
        rojo: {
            backgroundColor: 'var(--rojo-error)',
        },
        grisL93: {
            backgroundColor: 'var(--gris-l93)',
        },
        grisL83: {
            backgroundColor: 'var(--gris-l83)',
        },
        grisL63: {
            backgroundColor: 'var(--gris-l63)',
        },
        grisL43: {
            backgroundColor: 'var(--gris-l43)',
        },
        enPreparacion: {
            '&::before': {
                background: 'linear-gradient(to left, var(--verde-exito) 50%, var(--gris-l93) 50%)',
            },
        },
        enProceso: {
            background: 'linear-gradient(to left, #ff0000 50%, #0000ff 50%)',
        },
        exito: {
            background: 'linear-gradient(to left, #ff0000 50%, #0000ff 50%)',
        },
        ocultarPrimero: (_h = {},
            _h[theme.breakpoints.down('sm')] = {
                '&:first-child': {
                    display: 'none',
                },
                '&:nth-last-child(3)': {
                    '&::before': {
                        background: 'var(--blanco)',
                    },
                },
            },
            _h),
        ocultarUltimo: (_j = {},
            _j[theme.breakpoints.down('sm')] = {
                '&:last-child': {
                    display: 'none',
                },
            },
            _j),
        colorRojoUltimaLinea: {
            '&:last-child': {
                '&::after': {
                    background: 'linear-gradient(to left, var(--gris-l93) 50%, var(--rojo-error) 50%)',
                },
            },
        },
    });
});
export default useStyles;
